import { createReducer, PayloadAction } from "@reduxjs/toolkit";

import { ActionTypes, IModeloDiarioPadrao } from "./types";

export const reducers = createReducer({} as IModeloDiarioPadrao, {
  [ActionTypes.SET]: (state, action: PayloadAction<IModeloDiarioPadrao>) =>
    action.payload,
});
